<div>
  <mat-card>
    <div class="row">
      <div class="col-sm-12">
        <h4 class="col-sm-auto p-3 station-settings">Custom Source Settings</h4>
        <div class="col-sm-12">
          <div class="col-sm-auto p-2">
            <form novalidate [formGroup]="sourceForm">
              <div class="col-sm-12">
                <mat-form-field appearance="outline" aria-autocomplete="off">
                  <mat-label>ID</mat-label>
                  <input matInput formControlName="id" type="number" autocomplete="off" />
                </mat-form-field>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline">
                  <mat-label>Name</mat-label>
                  <input matInput type="text" formControlName="name" />
                    <mat-error *ngIf="sourceForm.get('name').touched && sourceForm.get('name').hasError('required')"><b>Name</b> is required</mat-error>
                    <mat-error *ngIf="sourceForm.get('name').touched && sourceForm.get('name').hasError('minlength')">
                      <b>Name</b> must have at least {{sourceForm.get('name').getError("minlength").requiredLength }} characters</mat-error>
                </mat-form-field>

              </div>

              <div class="col-sm-12">
                <mat-form-field appearance="outline">
                  <mat-label>Short Name</mat-label>
                  <input matInput type="text" formControlName="shortname" />
                  <mat-error *ngIf="sourceForm.get('shortname').touched && sourceForm.get('shortname').hasError('required')">
                    <b>Shortname</b> is required</mat-error>
                </mat-form-field>

              </div>
              <div class="button-row">
                <button type="button" [disabled]="!sourceForm.valid" (click)="onFormSubmit()" data-testid="confirm-button" mat-raised-button class="confirm">
                  Confirm
                </button>
                <button type="reset" data-testid="cancel-button" mat-raised-button color="accent">
                  Cancel
                </button>
                <button type="button" [disabled]="!sourceForm.valid || !sourceForm.get('id').value" data-testid="remove-button" mat-raised-button color="primary"
                  (click)="deleteSource()">
                  Remove
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>